export const toTwoDecimalPlaces =  (number, locale) => {
  return number.toLocaleString(locale, { maximumFractionDigits: 2, minimumFractionDigits: 2 })
}